import { marked } from 'marked'
import { generateSitemapContent } from './sitemap.js'

// 导入所有markdown文件
const markdownModules = import.meta.glob('../articles/*/index.md', { 
  query: '?raw', 
  import: 'default' 
})

// 博客文章列表配置
export const blogArticles = [
  {
    id: 'freenotion',
    title: '如何用EDU.KG域名免费获取Notion教育Plus版',
    date: '2025-08-13',
    summary: '利用.edu.kg教育域名免费申请Notion教育Plus版本，享受无限文件上传、高级协作等功能，教程简单易懂。',
    folder: 'freenotion',
    tags: ['教程', 'Notion', '白嫖', 'EDU'],
    heroImage: '/bg.jpg'
  },
  {
    id: 'registeredukg',
    title: '如何低价注册一个属于自己的EDU.KG域名',
    date: '2025-08-13',
    summary: '详细介绍如何注册吉尔吉斯斯坦的.edu.kg域名教程。无需教育资质验证，年费仅需22元，可用于Notion的教育认证。',
    folder: 'registeredukg',
    tags: ['教程', '域名', 'EDU'],
    heroImage: '/bg.jpg'
  },
  {
    id: 'sublinke',
    title: 'sublinkE：sublinkX二次开发版本，支持更多协议以及高度定制化功能',
    date: '2025-05-29',
    summary: '基于sublinkX的增强版节点订阅转换管理系统，新增Clash dialer-proxy支持、API访问控制、订阅自动化更新等功能，支持更多协议如AnyTLS、Socks5。',
    folder: 'sublinke',
    tags: ['开源', '代理', '订阅转换', 'Clash', 'Docker', 'Go'],
    heroImage: '/bg.jpg'
  },
  {
    id: 'euthenticator',
    title: 'Euthenticator: 打造一款纯本地的TOTP身份验证器',
    date: '2025-04-28',
    summary: '基于Go语言和Wails框架开发的桌面端TOTP身份验证器，支持纯本地加密存储、多源导入、跨平台兼容，为桌面用户提供安全便捷的2FA验证体验。',
    folder: 'euthenticator',
    tags: ['开源', '安全', 'TOTP', '2FA', 'Go', 'Wails', '桌面应用'],
    heroImage: '/bg.jpg'
  },
]

// 加载Markdown文件内容
export async function loadMarkdownContent(folder) {
  try {
    const modulePath = `../articles/${folder}/index.md`
    const moduleLoader = markdownModules[modulePath]
    
    if (moduleLoader) {
      const markdown = await moduleLoader()
      return marked(markdown)
    } else {
      throw new Error(`Markdown file for folder ${folder} not found`)
    }
  } catch (error) {
    console.error('Failed to load markdown file:', error)
    return '<p>文章加载失败</p>'
  }
}

// 从内容中提取摘要（前150个字符）
export function extractSummary(content, maxLength = 150) {
  // 移除HTML标签
  const text = content.replace(/<[^>]*>/g, '')
  return text.length > maxLength ? text.substring(0, maxLength) + '...' : text
}

// 根据ID获取文章信息
export function getArticleById(id) {
  return blogArticles.find(article => article.id === id)
}

// 格式化日期
export function formatDate(dateString) {
  const date = new Date(dateString)
  return date.toLocaleDateString('zh-CN', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  })
}

// 初始化时更新sitemap（仅在开发环境）
if (import.meta.env.DEV) {
  generateSitemapContent()
}
